import { Route, Routes } from '@packages/router-dom';
import { MODULE_PATHS, PUBLIC_CUSTOM_PAGE_PATH } from '../../../../ReactSharedScripts/utils/const';

import {
	AboutUsEntry,
	ActivityListEntry,
	ApiUserDetailEntry,
	ApiUserListEntry,
	ApplicationFormEntry,
	ApplicationsDetailEntry,
	ApplicationsListEntry,
	AuditTrailListEntry,
	AuthenticationEntry,
	BackofficeActionPageEntry,
	BureauDetailEntry,
	BureauListEntry,
	CandidateChangeListEntry,
	CandidateDetailEntry,
	CandidateListEntry,
	CandidatePensionListEntry,
	CaoCustomAgreementListEntry,
	CaoInstanceListEntry,
	CaoListEntry,
	CaoNewsDetailEntry,
	CaoNewsListEntry,
	CaoWagesListEntry,
	CaoWagesRequestDetailEntry,
	CaoWagesRequestListEntry,
	ClockwiseDetailEntry,
	CommentsListEntry,
	CommunitiesDetailEntry,
	CommunitiesListEntry,
	ComponentModelDetailEntry,
	ComponentModelListEntry,
	ConnectSettingsDetailEntry,
	ContactPersonDetailEntry,
	ContactPersonListEntry,
	ContractsDetailEntry,
	ContractsListEntry,
	ContractsUpdateDetailEntry,
	ContractsUpdateListEntry,
	CookiePolicyEntry,
	CustomCaoInstanceListEntry,
	CustomerDetailEntry,
	CustomerInvoiceComponentListEntry,
	CustomerInvoiceDetailEntry,
	CustomerInvoiceListEntry,
	CustomerListEntry,
	CustomerSubscriptionsDetailEntry,
	CustomerSubscriptionsListEntry,
	CustomPageErrorEntry,
	CustomPageMaintenanceEntry,
	CvdPolicyEntry,
	DashboardEntry,
	DocumentListEntry,
	DocumentSettingsDetailEntry,
	DocumentSettingsListEntry,
	DocumentTemplateDetailEntry,
	DocumentTemplateListEntry,
	DomainValueCaoMappingEntry,
	DomainValueMappingEntry,
	DomainValuesDetailEntry,
	DomainValuesListEntry,
	EmailSenderAuthDetailEntry,
	EmailSenderAuthListEntry,
	EmployerDetailEntry,
	EmployerListEntry,
	FormsDetailEntry,
	FormsListEntry,
	FormsPublicEntry,
	FsApiLogListEntry,
	HomeEntry,
	IllnessDetailEntry,
	IllnessListEntry,
	IncomingMessageDetailEntry,
	IncomingMessageListEntry,
	IncomingMessageLogListEntry,
	InvoiceListEntry,
	IssueDetailEntry,
	JobBoardDetailEntry,
	JobBoardInstanceDetailEntry,
	JobBoardInstanceListEntry,
	JobBoardListEntry,
	JobDetailEntry,
	JobListEntry,
	JobPostDetailEntry,
	JobPostListEntry,
	JournalTransferFilesListEntry,
	KeyIndicatorsEntry,
	LabelDetailEntry,
	LabelListEntry,
	ManagementInformationEntry,
	ModelMatrixDetailEntry,
	ModelMatrixEntry,
	ModelMatrixInstanceDetailEntry,
	ModelMatrixInstanceEntry,
	NewsAdminDetailEntry,
	NewsAdminListEntry,
	NewsDetailEntry,
	NewsListEntry,
	OptOutListEntry,
	OutgoingMessageDetailEntry,
	OutgoingMessageListEntry,
	OutgoingMessageLogListEntry,
	PageDetailEntry,
	PageListEntry,
	PaymentListEntry,
	PayslipsDetailEntry,
	PayslipsListEntry,
	PhaseListEntry,
	PlaygroundEntry,
	PrivacyStatementEntry,
	ProformaDetailEntry,
	ProformaListEntry,
	PublicDocumentAuthenticationEntry,
	PublicDocumentListEntry,
	PublicEmployerDetailEntry,
	PublicEmployerListEntry,
	PublicJobAllJobsEntry,
	PublicJobApplyEntry,
	PublicJobDetailEntry,
	PublicJobListEntry,
	PublicNewsDetailEntry,
	PublicNewsListEntry,
	PurchaseInvoiceListEntry,
	RateClassDetailEntry,
	RateClassEntry,
	ReservationListEntry,
	RolesDetailEntry,
	RolesListEntry,
	SafetyListEntry,
	SavedFilterAdminListEntry,
	SavedFilterLogListEntry,
	SavedFilterMyListEntry,
	SavedFilterOwnListEntry,
	SecurityStatementEntry,
	SettingEntry,
	ShareLogDetailEntry,
	ShareLogListEntry,
	SubscriberListEntry,
	SubscriptionSettingDetailEntry,
	SubscriptionSettingListEntry,
	SupplierListEntry,
	SupportAccessListEntry,
	SurveyAdminDetailEntry,
	SurveyAdminListEntry,
	SurveyDetailEntry,
	SurveyListEntry,
	SurveyPublicEntry,
	SurveyPublicOptOutEntry,
	TagListEntry,
	TaskListEntry,
	TemplateDetailEntry,
	TemplateListEntry,
	TermOfUseEntry,
	TextModelDetailEntry,
	TextModelListEntry,
	TimecardListEntry,
	TranslationDetailEntry,
	TranslationListEntry,
	UserDetailEntry,
	UserListEntry,
	UserProfileEntry,
	WmlListEntry,
} from '../../../../ReactSharedScripts/modules/app/sharedAppEntries';
import {
	AutomationDetailEntry,
	AutomationListEntry,
	AutomationLogListEntry,
	BackofficePaymentTransferFilesListEntry,
	BackofficeProcessingListEntry,
	CalculationSchemeDetailEntry,
	CalculationSchemeListEntry,
	CalculationSchemeTestDetailEntry,
	CandidateStatusMappingListEntry,
	CaoCustomAgreementDetailEntry,
	CaoDetailEntry,
	CaoInstanceDetailEntry,
	ClockwiseCompactViewEntry,
	ConnectorDetailEntry,
	ConnectorListEntry,
	CustomCaoInstanceDetailDetailEntry,
	DealsDetailEntry,
	DealsListEntry,
	FlexNetCustomerDetailEntry,
	FlexNetCustomerListEntry,
	FlexNetHostDetailEntry,
	FlexNetHostListEntry,
	FlexNetHostSettingsEntry,
	FormDesignerDetailEntry,
	FormDesignerListEntry,
	PeriodicComponentsListEntry,
	StructureEntry,
	WmlDetailEntry,
} from './appEntries';
import { memo } from 'react';
import { PageNotFound } from '../../../../ReactSharedScripts/modules/customPage/error/PageNotFound';

export const AppRoutes = memo(() => {
	return (
		<Routes>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.maintenance}
				element={<CustomPageMaintenanceEntry />}
			/>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.error}
				element={<CustomPageErrorEntry />}
			/>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.home}
				element={<HomeEntry />}
			/>
			<Route
				path={MODULE_PATHS.authentication}
				element={<AuthenticationEntry />}
			/>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.securityStatement}
				element={<SecurityStatementEntry />}
			/>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.privacyStatement}
				element={<PrivacyStatementEntry />}
			/>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.aboutUs}
				element={<AboutUsEntry />}
			/>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.termsOfUse}
				element={<TermOfUseEntry />}
			/>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.cookiePolicy}
				element={<CookiePolicyEntry />}
			/>
			<Route
				path={PUBLIC_CUSTOM_PAGE_PATH.cvdPolicy}
				element={<CvdPolicyEntry />}
			/>
			<Route
				path={MODULE_PATHS.userList}
				element={<UserListEntry />}
			/>
			<Route
				path={MODULE_PATHS.payslipList}
				element={<PayslipsListEntry />}
			/>
			<Route
				path={MODULE_PATHS.jobBoardList}
				element={<JobBoardListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.jobBoardDetails}/:id`}
				element={<JobBoardDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.jobBoardInstanceList}
				element={<JobBoardInstanceListEntry />}
			/>
			<Route
				path={MODULE_PATHS.documentTemplateList}
				element={<DocumentTemplateListEntry />}
			/>
			<Route
				path={MODULE_PATHS.candidatePensionList}
				element={<CandidatePensionListEntry />}
			/>
			<Route
				path={MODULE_PATHS.formList}
				element={<FormsListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.formPublic}/:id`}
				element={<FormsPublicEntry />}
			/>
			<Route
				path={MODULE_PATHS.formPublicViaLink}
				element={<FormsPublicEntry />}
			/>
			<Route
				path={MODULE_PATHS.documentList}
				element={<DocumentListEntry />}
			/>
			<Route
				path={MODULE_PATHS.clockwiseList}
				element={<TimecardListEntry />}
			/>
			<Route
				path={MODULE_PATHS.emailSenderAuthList}
				element={<EmailSenderAuthListEntry />}
			/>
			<Route
				path={MODULE_PATHS.caoNewsList}
				element={<CaoNewsListEntry />}
			/>
			<Route
				path={MODULE_PATHS.rolesList}
				element={<RolesListEntry />}
			/>
			<Route
				path={MODULE_PATHS.caoList}
				element={<CaoListEntry />}
			/>
			<Route
				path={MODULE_PATHS.customCaoList}
				element={<CaoCustomAgreementListEntry />}
			/>
			<Route
				path={MODULE_PATHS.customCaoInstanceList}
				element={<CustomCaoInstanceListEntry />}
			/>
			<Route
				path={MODULE_PATHS.caoListInstance}
				element={<CaoInstanceListEntry />}
			/>
			<Route
				path={MODULE_PATHS.caoWagesList}
				element={<CaoWagesListEntry />}
			/>
			<Route
				path={MODULE_PATHS.contractsList}
				element={<ContractsListEntry />}
			/>
			<Route
				path={MODULE_PATHS.contractsUpdateList}
				element={<ContractsUpdateListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.contractsUpdateDetail}/:id`}
				element={<ContractsUpdateDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.wmlList}
				element={<WmlListEntry />}
			/>
			<Route
				path={MODULE_PATHS.candidateList}
				element={<CandidateListEntry />}
			/>
			<Route
				path={MODULE_PATHS.employerList}
				element={<EmployerListEntry />}
			/>
			<Route
				path={MODULE_PATHS.auditTrailList}
				element={<AuditTrailListEntry />}
			/>
			<Route
				path={MODULE_PATHS.fsApiLogList}
				element={<FsApiLogListEntry />}
			/>
			<Route
				path={MODULE_PATHS.caoWagesRequestList}
				element={<CaoWagesRequestListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.agencyList}`}
				element={<BureauListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.translationList}`}
				element={<TranslationListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.invoiceList}`}
				element={<InvoiceListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.purchaseInvoiceList}`}
				element={<PurchaseInvoiceListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.supportAccessList}`}
				element={<SupportAccessListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.documentSettingsList}`}
				element={<DocumentSettingsListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.activityList}`}
				element={<ActivityListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.activityTaskList}`}
				element={<TaskListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.phaseList}`}
				element={<PhaseListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.reservationList}`}
				element={<ReservationListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.paymentList}`}
				element={<PaymentListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.candidateChangeList}`}
				element={<CandidateChangeListEntry />}
			/>
			<Route
				path={MODULE_PATHS.jobList}
				element={<JobListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.newsList}`}
				element={<NewsListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.newsadminList}`}
				element={<NewsAdminListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.communitiesList}`}
				element={<CommunitiesListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.commentsList}`}
				element={<CommentsListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.applicationsList}`}
				element={<ApplicationsListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.suppliersList}`}
				element={<SupplierListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.outgoingMessageList}`}
				element={<OutgoingMessageListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.customerList}`}
				element={<CustomerListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.customerInvoiceComponentList}`}
				element={<CustomerInvoiceComponentListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.tagList}`}
				element={<TagListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.surveyList}`}
				element={<SurveyListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.customerInvoiceList}`}
				element={<CustomerInvoiceListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.subscriptionSettingList}`}
				element={<SubscriptionSettingListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.labelList}`}
				element={<LabelListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.publicJobList}`}
				element={<PublicJobListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.journalTransferFilesList}`}
				element={<JournalTransferFilesListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.labelDetails}/:id`}
				element={<LabelDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.templateList}`}
				element={<TemplateListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.savedFilterLogsList}`}
				element={<SavedFilterLogListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.textModelList}`}
				element={<TextModelListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.surveyCommonDetails}/:id`}
				element={<SurveyDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.employerCommonDetails}/:id`}
				element={<EmployerDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.documentTemplateDetails}/:id`}
				element={<DocumentTemplateDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.jobCommonDetails}/:id`}
				element={<JobDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.agencyCommonDetails}/:id`}
				element={<BureauDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.candidateCommonDetailsNew}/:id`}
				element={<CandidateDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.newsCommonDetails}/:id`}
				element={<NewsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.newsAdminCommonDetails}/:id`}
				element={<NewsAdminDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.communitiesCommonDetails}/:id`}
				element={<CommunitiesDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.contractCommonDetails}/:id`}
				element={<ContractsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.clockwiseDetail}/:id`}
				element={<ClockwiseDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.contactPersonDetail}/:id`}
				element={<ContactPersonDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.contactPersonList}`}
				element={<ContactPersonListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.payslipsCommonDetails}/:id`}
				element={<PayslipsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.textModelDetails}/:id`}
				element={<TextModelDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.applicationsCommonDetails}/:id`}
				element={<ApplicationsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.emailSenderAuthCommonDetails}/:id`}
				element={<EmailSenderAuthDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.userCommonDetails}/:id`}
				element={<UserDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.rolesCommonDetails}/:id`}
				element={<RolesDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.caoWagesRequestDetails}/:id`}
				element={<CaoWagesRequestDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.illnessCommonDetails}/:id`}
				element={<IllnessDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.illnessList}`}
				element={<IllnessListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.documentSettingsDetail}/:id`}
				element={<DocumentSettingsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.translationDetails}/:id`}
				element={<TranslationDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.modelMatrixDetail}/:id`}
				element={<ModelMatrixDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.modelMatrixInstanceDetail}/:id`}
				element={<ModelMatrixInstanceDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.dashboard}`}
				element={<DashboardEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.formCommonDetails}/:id`}
				element={<FormsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.caoNewsDetail}/:id`}
				element={<CaoNewsDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.rateClassList}
				element={<RateClassEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.rateClassDetail}/:id`}
				element={<RateClassDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.proformaList}
				element={<ProformaListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.proformaDetails}/:id`}
				element={<ProformaDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.incomingMessage}/:id?`}
				element={<IncomingMessageDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.incomingMessageList}
				element={<IncomingMessageListEntry />}
			/>
			<Route
				path={MODULE_PATHS.incomingMessageLogList}
				element={<IncomingMessageLogListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.userProfile}`}
				element={<UserProfileEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.publicDocumentAuthentication}`}
				element={<PublicDocumentAuthenticationEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.publicDocumentList}`}
				element={<PublicDocumentListEntry />}
			/>
			<Route
				path={MODULE_PATHS.apiUserList}
				element={<ApiUserListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.apiUserCommonDetails}/:id`}
				element={<ApiUserDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.outgoingMessageLogList}
				element={<OutgoingMessageLogListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.outgoingMessageDetails}/:id?`}
				element={<OutgoingMessageDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.connectSettings}
				element={<ConnectSettingsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.templateDetails}/:id`}
				element={<TemplateDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.surveyAdminDetails}/:id`}
				element={<SurveyAdminDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.surveyAdminList}`}
				element={<SurveyAdminListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.surveyPublic}/:id`}
				element={<SurveyPublicEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.surveyOptOut}/:id`}
				element={<SurveyPublicOptOutEntry />}
			/>
			<Route
				path={MODULE_PATHS.shareLogList}
				element={<ShareLogListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.shareLogDetail}/:id`}
				element={<ShareLogDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.optOutList}`}
				element={<OptOutListEntry />}
			/>
			<Route
				path={MODULE_PATHS.customerSubscriptionsList}
				element={<CustomerSubscriptionsListEntry />}
			/>
			<Route
				path={MODULE_PATHS.safetyList}
				element={<SafetyListEntry />}
			/>
			<Route
				path={MODULE_PATHS.pageList}
				element={<PageListEntry />}
			/>
			<Route
				path={MODULE_PATHS.savedFilterMyList}
				element={<SavedFilterMyListEntry />}
			/>
			<Route
				path={MODULE_PATHS.savedFilterOwnList}
				element={<SavedFilterOwnListEntry />}
			/>
			<Route
				path={MODULE_PATHS.savedFilterAdminList}
				element={<SavedFilterAdminListEntry />}
			/>
			<Route
				path={MODULE_PATHS.modelMatrixList}
				element={<ModelMatrixEntry />}
			/>
			<Route
				path={MODULE_PATHS.modelMatrixInstanceList}
				element={<ModelMatrixInstanceEntry />}
			/>
			<Route
				path={MODULE_PATHS.componentModelList}
				element={<ComponentModelListEntry />}
			/>
			<Route
				path={MODULE_PATHS.settingList}
				element={<SettingEntry />}
			/>
			<Route
				path={MODULE_PATHS.connectDashboardList}
				element={<KeyIndicatorsEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.customerDetails}/:id`}
				element={<CustomerDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.customerInvoiceDetails}/:id`}
				element={<CustomerInvoiceDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.customerSubscriptionsDetails}
				element={<CustomerSubscriptionsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.subscriptionSettingDetails}/:id`}
				element={<SubscriptionSettingDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.subscriberList}
				element={<SubscriberListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.componentModelDetail}/:id`}
				element={<ComponentModelDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.jobPostList}
				element={<JobPostListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.jobPostDetail}/:id`}
				element={<JobPostDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.pageDetails}`}
				element={<PageDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.jobBoardInstanceDetail}/:id`}
				element={<JobBoardInstanceDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.playground}`}
				element={<PlaygroundEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.domainValueList}`}
				element={<DomainValuesListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.domainValueDetail}/:id`}
				element={<DomainValuesDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.allJobs}
				element={<PublicJobAllJobsEntry />}
			/>
			<Route
				path={MODULE_PATHS.publicNewsList}
				element={<PublicNewsListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.publicNewsDetail}/:id`}
				element={<PublicNewsDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.applicationForm}
				element={<ApplicationFormEntry />}
			/>
			<Route
				path={MODULE_PATHS.structure}
				element={<StructureEntry />}
			/>

			{/*desktop specific*/}
			<Route
				path={MODULE_PATHS.dealsList}
				element={<DealsListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.automationLogList}`}
				element={<AutomationLogListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.automationDetails}/:id`}
				element={<AutomationDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.automationList}
				element={<AutomationListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.periodicComponentsList}`}
				element={<PeriodicComponentsListEntry />}
			/>
			<Route
				path={MODULE_PATHS.flexNetHostList}
				element={<FlexNetHostListEntry />}
			/>
			<Route
				path={MODULE_PATHS.flexNetCustomerList}
				element={<FlexNetCustomerListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.flexNetHostDetail}/:id`}
				element={<FlexNetHostDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.flexNetCustomerDetail}/:id`}
				element={<FlexNetCustomerDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.flexNetHostSettingsDetail}`}
				element={<FlexNetHostSettingsEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.clockwiseCompactView}`}
				element={<ClockwiseCompactViewEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.caoDetails}/:id`}
				element={<CaoDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.customCaoDetails}/:id`}
				element={<CaoCustomAgreementDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.customCaoInstanceDetails}/:id`}
				element={<CustomCaoInstanceDetailDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.calculationSchemeList}`}
				element={<CalculationSchemeListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.calculationSchemeDetails}/:id`}
				element={<CalculationSchemeDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.formDesignerDetail}/:id`}
				element={<FormDesignerDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.formDesignerList}`}
				element={<FormDesignerListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.testCalculationScheme}/:id`}
				element={<CalculationSchemeTestDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.caoInstanceDetails}/:id`}
				element={<CaoInstanceDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.wmlDetails}/:id`}
				element={<WmlDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.candidateStatusMappingList}
				element={<CandidateStatusMappingListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.dealsCommonDetails}/:id`}
				element={<DealsDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.domainValueMappingList}`}
				element={<DomainValueMappingEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.domainValueCaoMappingList}`}
				element={<DomainValueCaoMappingEntry />}
			/>
			<Route
				path={MODULE_PATHS.connectorList}
				element={<ConnectorListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.connectorDetail}/:id`}
				element={<ConnectorDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.issueDetail}
				element={<IssueDetailEntry />}
			/>
			<Route
				path={MODULE_PATHS.publicEmployerList}
				element={<PublicEmployerListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.publicEmployerDetail}/:id`}
				element={<PublicEmployerDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.publicJobDetail}/:id`}
				element={<PublicJobDetailEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.publicJobApply}/:id`}
				element={<PublicJobApplyEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.managementInformation}`}
				element={<ManagementInformationEntry />}
			/>
			<Route
				path={MODULE_PATHS.backofficeActionPage}
				element={<BackofficeActionPageEntry />}
			/>
			<Route
				path={MODULE_PATHS.backofficePaymentTransferFilesList}
				element={<BackofficePaymentTransferFilesListEntry />}
			/>
			<Route
				path={`${MODULE_PATHS.backofficeProcessingList}`}
				element={<BackofficeProcessingListEntry />}
			/>
			<Route
				path='*'
				element={<PageNotFound />}
			/>
		</Routes>
	);
});
